import React from 'react'
import PropTypes from 'prop-types'

import './ListSelector.css'

class Header extends React.Component {

  render() {
    return (
      <div
        className='header'
        style={{
          color: '#' + this.props.foreground,
          backgroundColor: '#' + this.props.background
        }}
      >
        {this.props.text}
      </div>
    )
  }
}

Header.propTypes = {
  text: PropTypes.string.isRequired,
  foreground: PropTypes.string,
  background: PropTypes.string
}

Header.defaultProps = {
  foreground: '000000',
  background: 'ffffff'
}

class Item extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // Bind events
    this.onClick = this.onClick.bind(this)
  }

  onClick() {
    this.props.onClick(this.props.value)
  }

  render() {
    return (
      <div
        className={'item' + (this.props.selected ? ' selected' : '')}
        onClick={this.onClick}
        style={{
          paddingLeft: (4 + this.props.level*16) + 'px'
        }}
      >
        {this.props.text}
        {
          this.props.status
            ? <div
                style={{
                  float: 'right'
                }}
              >
                {this.props.status}
              </div>
            : null
        }
      </div>
    )
  }
}

Item.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]).isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.element.isRequired
  ]).isRequired,
  level: PropTypes.number,
  status: PropTypes.element
}

Item.defaultProps = {
  level: 0
}

class ListSelector extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      selected: this.props.selected || null
    }

    // Bind events
    this.onClickItem = this.onClickItem.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // When selection changed, notify above
    if (prevState.selected !== this.state.selected) {
      this.props.onSelect(this.state.selected)
    }

    // When props changes, change state accordingly
    if (prevProps.selected !== this.props.selected) {
      this.setState({
        selected: this.props.selected
      })
    }
  }

  onClickItem(value) {
    this.setState({
      selected: value
    })
  }

  render() {
    const { onSelect, usesStickers, children, ...props } = this.props
    const improveChildren = (children) => (
      React.Children.map(children, (child) => {
        if (child.type === Item) {
          return React.cloneElement(
            child,
            {
              onClick: this.onClickItem,
              selected: child.props.value === this.state.selected
            }
          )
        }
        else {
          return child
        }
      })
    )
    return (
      <div
        className={'list-selector' + (usesStickers ? ' uses-stickers' : '')}
        {...props}
      >
        {improveChildren(children)}
      </div>
    )
  }
}

ListSelector.propTypes = {
  selected: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  usesStickers: PropTypes.bool
}

ListSelector.Header = Header
ListSelector.Item = Item

export default ListSelector



// WEBPACK FOOTER //
// ./src/components/elements/ListSelector.js